import { type ItemOf } from '@shared/board'
import { type Node, type NodeProps } from '@xyflow/react'
import { SessionNodeView } from '../../items/SessionNodeView'
import { Handles } from './Handles'

/** A conversation placed on the board, as a React Flow node. */
export function SessionNode({
  data: { item },
  selected,
}: NodeProps<Node<{ item: ItemOf<'session'> }, 'session'>>) {
  return (
    <div className="relative">
      <SessionNodeView item={item} selected={selected} />
      <Handles />
    </div>
  )
}
